import React, { useMemo } from 'react';
import { PATH } from "../../routes/path-list";
import { Route, Redirect } from 'react-router-dom';
import { ROLES_ROUTES } from "../../variables/roles-permissions";
import WebCaptureLayout from '../../components/layout/web-capture-layout';
import { checkPermisions } from "../../components/permissions";
import { UserService } from "../../services/user-service";

export const PrivateRouteByRole = (props) => {
    const roles = UserService.getRoles();
    const hasPermission = checkPermisions(ROLES_ROUTES, props.basepath, roles);

    const RouteComponent = useMemo(() => {
        if (!hasPermission) return null;
        
        return (matchProps) => (
            <WebCaptureLayout>
                <props.component {...matchProps} />
            </WebCaptureLayout>
        );
    }, [props.component, hasPermission]);

    if (!hasPermission) {
        return <Route {...props} component={() => <Redirect to={PATH.HOME} />} />;
    }

    return <Route {...props} component={RouteComponent} />;
};

export default PrivateRouteByRole;